import { render, staticRenderFns } from "./AddInfoForm.vue?vue&type=template&id=b6d639c2&scoped=true"
import script from "./AddInfoForm.vue?vue&type=script&lang=js"
export * from "./AddInfoForm.vue?vue&type=script&lang=js"
import style0 from "./AddInfoForm.vue?vue&type=style&index=0&id=b6d639c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d639c2",
  null
  
)

export default component.exports